var _config = {};
_config['default_avatar'] = '//pic1.58cdn.com.cn/p1/n_v1bkuymc2tsxlfo5wrgb7a.png';
//游客默认头像
_config['default-anonymous-avatar'] = 'https://img.58cdn.com.cn/git/teg-app-fe/im-images/default-images/avatar/anonymous-avatar@2x.png';

_config['me'] = function () {
};
// 消息转换器，将消息结构转换成相应ui的标准结构
_config['msg-show-converter'] = function (msg) {
  return msg;
};
// 发送消息转换器，将内部标准消息结构转换成发送需要的结构
_config['msg-send-converter'] = function (msg) {
  return msg;
};
// 会话上展示的消息转换器
_config['session-msg-converter'] = function (msg) {
  return msg;
};
// 是否显示头像
_config['msg-avatar'] = true;
// 埋点统计
_config['stat'] = {
  appversion: '1.0',
  appid: '123',
  appkey: 'abcdefg',
  cookiename: 'wmda',
  pn: 'demo',
  reportIntervalTime: 5,
  reportIntervalCount: 3
};
// 消息声音提醒
_config['msg-sound'] = 'https://wx.qq.com/zh_CN/htmledition/v2/sound/msg.mp3';
// 默认卡片图片
_config['default-card-img'] = '//pic3.58cdn.com.cn/nowater/webim/big/n_v1bl2lwxtpeksfrr3aea3q.png';
// 获取用户信息
_config['getUserinfo'] = function () {
};
// 默认用户的source
_config['default-source'] = '';
// 绑定手机号
_config['bind-cellphone'] = function () {
};
// 入口handler
_config['entry-handler'] = function () {
};
// 浏览器标题handler
_config['title-handler'] = function () {
};
// 店铺通用卡片ajax请求域名
_config['shop_common_card_api_host'] = '';
// 切换会话时，获取当前会话对象；主页下，两参数均为''
_config['on-contactchange'] = function (to_id, to_source) {
};
// 聊天页面创建完毕回调方法（外部可根据用户id，source进行输入框隐藏）
_config['on-chatwindowcreate'] = function (user_id, user_source) {
};
// 聊天页面创建完毕回调方法（外部可根据用户id，source进行输入框隐藏）
_config['on-chatwindow-create'] = function (u_id, u_source) {
};
// session列表处理（如:将部分账号置顶）
_config['sessions-converter'] = function (sessions, cb) {
  cb(sessions);
};
// 信质对应的user_source
_config['xz-source'] = '';

// 点击特定会话的操作
_config['on-session-item-click'] = function (contact) {
  let isGotoChat = true;
  return isGotoChat;
};
//获取匿名登陆输入模版
_config['get-template-msg'] = function(){
};
_config['jf_client_type'] = 'm';

_config['global_css_configs'] = {};
// 提醒服务ID
_config['notice_user_id'] = '75969072527136';
//语音
_config['audio-converter'] = function (url) {
  var newUrl;
  // 对于已经转换过的语音链接，进行https转换
  if (typeof (url) === 'string' && url.indexOf('audioconvert.58.com') > -1) {
    if (url.indexOf('http://audioconvert.58.com') === 0) {
      newUrl = url.replace('http', 'https');
    } else if (url.indexOf('//audioconvert.58.com') === 0) {
      newUrl = 'https:' + url;
    } else if (url.indexOf('audioconvert.58.com') === 0) {
      newUrl = 'https://' + url;
    } else if (url.indexOf('https://audioconvert.58.com') === 0) {
      newUrl = url;
    }
  } else {
    newUrl = 'https://audioconvert.58.com/convert?amrurl=' + encodeURIComponent(url);
  }
  return newUrl;
};

export default {
  set: function (config) {
    Object.assign(_config, config);
  },
  get: function (key) {
    return _config[key];
  }
};
